import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { BrandLogo } from '../../app/brand/BrandLogo';
import { Icon } from '../../ui';
import { OPERATOR } from './identity';
import styles from './Acquisition.module.css';

export function TrialPromise() {
  return (
    <div className={styles.trialPromise}>
      <Icon name="shield-check" size={20} />
      <strong>No credit card required.</strong>
      <span>No automatic charges.</span>
    </div>
  );
}

export function AcquisitionLayout({ children }: { children: ReactNode }) {
  const location = useLocation();
  const preview = new URLSearchParams(location.search).get('preview') === '1';
  const suffix = preview ? '?preview=1' : '';
  return (
    <div className={styles.page}>
      {preview && (
        <div className={styles.previewBanner}>
          <strong>Interactive preview</strong>
          <span>No account is created. No email is sent.</span>
          <Link to="/signup">Exit preview</Link>
        </div>
      )}
      <a
        href="#main-content"
        className={styles.skip}
        onClick={(event) => {
          event.preventDefault();
          const main = document.getElementById('main-content');
          main?.setAttribute('tabindex', '-1');
          main?.focus();
          main?.scrollIntoView();
        }}
      >
        Skip to content
      </a>
      <header className={styles.header}>
        <Link to="/" aria-label="AdOrchestrator home">
          <BrandLogo height={28} />
        </Link>
        {/* The account page is where a new member starts ("Get Started Here"); a "Back to site" link beside that
            action read as a competing exit (Jason, 2026-10-27). The logo at the top left is the way back to the
            site on every acquisition page, so the account page draws no navigation of its own. */}
        {location.pathname === '/account' ? null : (
          <nav aria-label="Main navigation">
            <Link to={'/login' + suffix}>Log in</Link>
            <Link className={styles.smallCta} to={'/signup' + suffix}>
              Start free trial <Icon name="arrow-right" size={16} />
            </Link>
          </nav>
        )}
      </header>
      {children}
      <footer className={styles.footer}>
        <div>
          <strong>AdOrchestrator</strong>
          <p>A service of {OPERATOR}.</p>
          <p>Independent of, and not affiliated with, Meta Platforms, Inc.</p>
        </div>
        <nav aria-label="Legal">
          <a href="mailto:support@adorchestrator.com">Contact support</a>
          <Link to="/terms">Terms of service</Link>
          <Link to="/privacy">Privacy policy</Link>
        </nav>
      </footer>
    </div>
  );
}
